export default {
  data() {
    return {
      page: 1, // 当前页
      pageSize: 30, // 每页数量
      tableData: [], // 表格数据
      total: 0, // 总数据
      tableLoading: false // table的loading状态
    }
  },
  watch: {
    $route() {
      this.initPage()
      this.initTable()
      this.getData('init') // 添加条件初始化搜索
    }
  },
  created() {
    this.initPage()
  },
  mounted() {
    this.getData('init')
  },
  methods: {
    initTable() { // 初始化表格数据
      this.page = 1
      this.pageSize = 30
      this.tableData = []
      this.total = 0
    },
    pageChange(page) {
      this.page = page
      this.getData()
    },
    pageSizeChange(size) {
      this.page = 1
      this.pageSize = size
      this.getData()
    },
    // 封装传参
    addQuery(query, name, value) {
      if (value !== undefined && value !== '') {
        query[name] = value
      }
      return query
    }
  }
}
